import HttpClient from './http-client';
import instance from './instance';

const newInstance = (resource: string, baseUrl?: string) =>
  new HttpClient(resource, baseUrl, instance);

export default newInstance;
